import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet-async';
import { pageTitle } from '../../../../util/pageTitles';
import Cookies from 'universal-cookie';
import Avatar from 'react-avatar';
import { withRouter } from '../../../../util/withRouter';
import { Button } from 'react-bootstrap';

import { handleError } from '../../AuthActions';
import ImageSize from '../../../../components/ImageSize/ImageSize';


// Import Style
import '../../Auth.scss';

const cookies = new Cookies();

class CompletePage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: '',
      image: '',
      email: '',
      edit: false,
    };
  }

  componentDidMount() {
    const user = cookies.get('tmpusr');
    if (user) {
      this.setState({
        email: user.email,
        name: user.name,
        image: user.image,
        edit: !user.name 
      });
    } else {
      this.setState({
        edit: true
      });
    }
  }

  continue = () => {
    if (!this.state.email) {
      this.props.handleError('Enter email address');
      return false;
    }

    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (!re.test(String(this.state.email).toLowerCase())) {
      this.props.handleError('Invalid email');
      return false;
    }

    global.window &&
      window.location &&
      window.location.replace(
        `/api/integrations/complete?user=${encodeURIComponent(
          this.props.location.query.user
        )}&email=${encodeURIComponent(this.state.email)}${
          this.props.location.query.app ? `&app=${this.props.location.query.app}` : ''
        }${this.props.location.query.setup ? `&setup=${this.props.location.query.setup}` : ''}${
          !!this.state.name ? `&name=${encodeURIComponent(this.state.name)}` : '' 
        }`
      );
  };

  render() {
    return (
      <div className='login_bg'>
        <Helmet>
          <title>{pageTitle('Setup account')}</title>
        </Helmet>
        <div className={`login_form setup_form  ${this.props.app}`}>
          <div className='login_content'>
              <h1 className="text-center">Set up your Nave account</h1>
              <div className='setup_avatar_image'>
                {this.state.image ? (
                  <ImageSize src={this.state.image} alt="" />
                ) : (
                  <Avatar name={this.state.name} size={38} round="4px" maxInitials={2} />
                )}
              </div>

              <div className='form_container'>
                <label>Name</label>
                { !this.state.edit ? (<input
                  className='form-control'
                  readOnly={true}
                  value={this.state.name}
                />) : (<input
                  className='form-control'
                  autoFocus={this.state.edit}
                  onChange={e => this.setState({ name: e.target.value })}
                  value={this.state.name}
                />) }
              </div>
              <div className='form_container'>
                <label>Email</label>
                <input
                  className='form-control'
                  autoFocus={!this.state.edit}
                  onChange={e => this.setState({ email: e.target.value })}
                  value={this.state.email}
                />
              </div>
              <Button
                variant="primary"
                disabled={!this.state.email}
                onClick={this.continue}
              >
                Set up your account
              </Button>

              <div className='spinner_path'>
                <svg width="74" height="76" viewBox="0 0 74 76" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M10 68.6321C10 68.6321 28.3719 76.9321 39.4765 66.2877C50.5819 55.6438 33.2447 43.5314 30.6131 47.4062C27.9819 51.2802 35.8712 64.5455 50.7697 
                          62.496C65.6686 60.4457 65.5571 44.0702 60.9616 35.8219C56.3662 27.5735 43.2679 14.174 37.5536 23.8535C31.8402 33.5336 64.406 52.5299 71.4147 35.635C78.422 
                          18.7405 42.4169 -2.13898 20.6291 1.39523" stroke="#254081" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"/>
                  <path d="M0 63.2516C4.70655 63.5811 10.8594 63.2961 15.1772 62L9.69641 67.6326L9.10185 75.47C7.21627 71.3719 3.36108 66.5645 0 63.2516Z" fill="#254081"/>
                </svg>
              </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    handleError: err => dispatch(handleError(err))
  };
};

export default withRouter(connect(null, mapDispatchToProps)(CompletePage));
